function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getDefaultSearchBean } from "@wikicasa/common/model/RealEstateSearchBean";
import { mapActions, mapState } from "pinia";
//@ts-ignore
import { deepCopy } from "@utils/ObjectUtils";
//@ts-ignore
import { isArrNullOrEmpty } from "@utils/ArrayUtils";
import { getBasePublicValuation } from "@customTypes/PublicValuation";
import { usePlaceType } from "@wkComposables/usePlaceType";
//@ts-ignore
import { usePlaceName } from "@wkComposables/usePlaceName";
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { PLACE_TYPE } from "@customTypes/PlaceType";
import { getDistrictsByZoneId, getPlace, getZones } from "@services/placesAPI";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { LocationIcon } from "@vueEntry/SvgIcons/LocationIcon";
//@ts-ignore
import { DrawIcon } from "@vueEntry/SvgIcons/DrawIcon";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import { getPlacesAddressAutocomplete } from "@services/geographyAPI";
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import BaseAccordionItem from "@vueEntry/UIKitComponents/Accordion/BaseAccordionItem.vue";
import { defineComponent } from "vue";
import { useSearchBeanStore } from "@store/SearchBeanStore";
export default defineComponent({
  name: "PlaceModal",
  components: {
    RadioButton: RadioButton,
    CheckboxBtn: CheckboxBtn,
    BaseAutocomplete: BaseAutocomplete,
    BaseBtModal: BaseBtModal,
    BaseButton: BaseButton,
    DrawIcon: DrawIcon,
    LocationIcon: LocationIcon,
    BaseAccordionItem: BaseAccordionItem
  },
  props: {
    showPlaceModal: {
      type: Boolean
    },
    listing: {
      type: Boolean
    },
    valuation: {
      type: Boolean
    },
    place: {
      type: Object
    },
    placedIn: {
      type: String,
      "default": "real-estate"
    },
    agencyGroup: {
      type: String,
      "default": ""
    }
  },
  emits: ["hide-place-modal", "show-map", "emit-place"],
  setup: function setup() {
    var _usePlaceName = usePlaceName(),
      currentPlaceName = _usePlaceName.currentPlaceName,
      locationLabel = _usePlaceName.locationLabel,
      zonesLabel = _usePlaceName.zonesLabel,
      setCustomPlaceLabel = _usePlaceName.setCustomPlaceLabel,
      updateLocationName = _usePlaceName.updateLocationName,
      updateZoneName = _usePlaceName.updateZoneName,
      updateSingleDistrictName = _usePlaceName.updateSingleDistrictName,
      updateGenericPlaceName = _usePlaceName.updateGenericPlaceName,
      updateCityName = _usePlaceName.updateCityName;
    var _usePlaceType = usePlaceType(),
      localityList = _usePlaceType.localityList,
      zoneList = _usePlaceType.zoneList,
      searchBeanModal = _usePlaceType.searchBeanModal,
      prevSelectedLocality = _usePlaceType.prevSelectedLocality,
      localitySelected = _usePlaceType.localitySelected,
      prevZoneIDsSelected = _usePlaceType.prevZoneIDsSelected,
      zoneIDsSelected = _usePlaceType.zoneIDsSelected,
      zoneModifiedByUser = _usePlaceType.zoneModifiedByUser,
      districtSelected = _usePlaceType.districtSelected,
      districtsObj = _usePlaceType.districtsObj,
      selectedDistrictLength = _usePlaceType.selectedDistrictLength,
      convertEnergyClassFilter = _usePlaceType.convertEnergyClassFilter,
      convertFloor = _usePlaceType.convertFloor,
      resetSearchBeanZonesAndLocalities = _usePlaceType.resetSearchBeanZonesAndLocalities,
      updateSearchModal = _usePlaceType.updateSearchModal,
      updateSearchModalAndPlace = _usePlaceType.updateSearchModalAndPlace,
      fixSearchBean = _usePlaceType.fixSearchBean,
      initZonesAndLocalities = _usePlaceType.initZonesAndLocalities,
      areAllDistrictsSelected = _usePlaceType.areAllDistrictsSelected,
      isZoneOrLocalitySelected = _usePlaceType.isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty = _usePlaceType.areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled = _usePlaceType.areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict = _usePlaceType.getSingleSelectedDistrict,
      getZoneById = _usePlaceType.getZoneById,
      resetZoneAndLocalities = _usePlaceType.resetZoneAndLocalities,
      isZoneSelected = _usePlaceType.isZoneSelected,
      isLocationSelected = _usePlaceType.isLocationSelected,
      isDistrictSelected = _usePlaceType.isDistrictSelected,
      insertDistrictByZoneId = _usePlaceType.insertDistrictByZoneId,
      onPlaceLIClick = _usePlaceType.onPlaceLIClick,
      onDistrictClick = _usePlaceType.onDistrictClick;
    var _useSearch = useSearch(),
      search = _useSearch.search;
    return {
      //Refs
      currentPlaceName: currentPlaceName,
      //Computed
      locationLabel: locationLabel,
      zonesLabel: zonesLabel,
      //Methods
      setCustomPlaceLabel: setCustomPlaceLabel,
      updateLocationName: updateLocationName,
      updateZoneName: updateZoneName,
      updateSingleDistrictName: updateSingleDistrictName,
      updateGenericPlaceName: updateGenericPlaceName,
      updateCityName: updateCityName,
      //usePlaceType
      localityList: localityList,
      zoneList: zoneList,
      searchBeanModal: searchBeanModal,
      prevSelectedLocality: prevSelectedLocality,
      localitySelected: localitySelected,
      prevZoneIDsSelected: prevZoneIDsSelected,
      zoneIDsSelected: zoneIDsSelected,
      zoneModifiedByUser: zoneModifiedByUser,
      districtSelected: districtSelected,
      districtsObj: districtsObj,
      //Computed
      selectedDistrictLength: selectedDistrictLength,
      //Methods
      convertEnergyClassFilter: convertEnergyClassFilter,
      convertFloor: convertFloor,
      resetSearchBeanZonesAndLocalities: resetSearchBeanZonesAndLocalities,
      updateSearchModal: updateSearchModal,
      updateSearchModalAndPlace: updateSearchModalAndPlace,
      fixSearchBean: fixSearchBean,
      initZonesAndLocalities: initZonesAndLocalities,
      areAllDistrictsSelected: areAllDistrictsSelected,
      isZoneOrLocalitySelected: isZoneOrLocalitySelected,
      areZonesAndLocalitiesEmpty: areZonesAndLocalitiesEmpty,
      areZonesAndLocalitiesFilled: areZonesAndLocalitiesFilled,
      getSingleSelectedDistrict: getSingleSelectedDistrict,
      getZoneById: getZoneById,
      resetZoneAndLocalities: resetZoneAndLocalities,
      isZoneSelected: isZoneSelected,
      isLocationSelected: isLocationSelected,
      isDistrictSelected: isDistrictSelected,
      insertDistrictByZoneId: insertDistrictByZoneId,
      onPlaceLIClick: onPlaceLIClick,
      onDistrictClick: onDistrictClick,
      //useSearch
      search: search
    };
  },
  data: function data() {
    return {
      valuationAddress: undefined,
      autocompleteValue: undefined,
      disableCb: true,
      placeTest: null,
      mapPlace: null,
      prevSearchBeanModal: getDefaultSearchBean(),
      showMapModal: false,
      aroundMe: false,
      tempListUpdated: false,
      tempZoneList: [],
      tempLocalityList: [],
      showZoneModal: false,
      previousPlaceName: "",
      cityModal: false,
      tempPlace: null,
      publicValuation: getBasePublicValuation(),
      openPlaceModal: false,
      pmCustomEvent: null,
      cautocompleteELSelected: false,
      modalBodyHeight: 0,
      agencyFilter: {
        name: "",
        franchiseId: null
      }
    };
  },
  computed: Object.assign({
    currentName: function currentName() {
      return this.currentPlaceName;
    },
    localitiesLabel: function localitiesLabel() {
      return window["_labels"].localities;
    },
    cdn: function cdn() {
      return window["_cdn"];
    },
    labels: function labels() {
      return window["_labels"];
    },
    hasValuationAddress: function hasValuationAddress() {
      var _a;
      return !!((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address);
    },
    address: function address() {
      return this.publicValuation.realEstateValuation.address;
    },
    agencyListingTypologyURL: function agencyListingTypologyURL() {
      return this.labels.macroTypology_url_5;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])),
  watch: {
    showPlaceModal: function showPlaceModal(cur) {
      this.openPlaceModal = cur;
    },
    cautocompleteELSelected: function cautocompleteELSelected(cur) {
      if (cur) {
        this.openCityModal();
      }
    },
    currentPlaceName: function currentPlaceName(cur, prev) {
      this.autocompleteValue = {
        label: cur
      };
    }
  },
  created: function created() {
    this.openPlaceModal = this.showPlaceModal;
    if (this.valuation) {
      this.openCityModal();
      return;
    }
    /*        if (this.place?.zoneID && isArrNullOrEmpty(this.zoneIDsSelected))
        this.zoneIDsSelected.push(this.place?.zoneID)*/
    this.updateSearchModal(this.searchBean);
    this.convertEnergyClassFilter();
    this.convertFloor();
    if (this.place) this.placeTest = deepCopy(this.place);
  },
  mounted: function mounted() {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this = this;
      var _this$searchBeanModal, zoneIdList, cityId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this.valuation) this.modalBodyHeight = (_a = document.querySelector("#place-modal .modal-body")) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            _this$searchBeanModal = this.searchBeanModal, zoneIdList = _this$searchBeanModal.zoneIdList, cityId = _this$searchBeanModal.cityId; // if (this.placeTest?.zoneID && !this.placeTest.districtID)
            if ((this.searchBeanModal.zoneId || ((_b = this.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.length) === 1) && (!this.searchBeanModal.districtId || !((_c = this.searchBeanModal.districtIdList) === null || _c === void 0 ? void 0 : _c.length))) {
              this.zoneIDsSelected = this.searchBeanModal.zoneId ? [this.searchBeanModal.zoneId] : this.searchBeanModal.zoneIdList;
              if (this.searchBeanModal.zoneId) this.searchBeanModal.zoneIdList = [this.searchBeanModal.zoneId];
            } else if (!isArrNullOrEmpty(zoneIdList) && !this.valuation && ((_d = this.placeTest) === null || _d === void 0 ? void 0 : _d.placeType) !== "D") {
              this.zoneIDsSelected = zoneIdList;
            } else if (((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) === PLACE_TYPE.DISTRICT) {
              this.searchBeanModal.zoneId = null;
              this.searchBeanModal.zoneIdList = [];
              this.zoneIDsSelected = [];
            }
            //Just one zone
            if (!cityId) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return this.initZonesAndLocalities(getZones(cityId));
          case 6:
            if (((_f = this.placeTest) === null || _f === void 0 ? void 0 : _f.placeType) === PLACE_TYPE.LOCALITY && this.searchBeanModal.localityIdList)
              //@ts-ignore
              this.localitySelected = this.localityList.find(function (l) {
                return l.localityID === _this.searchBeanModal.localityIdList[0];
              });
            this.updatePlaceName();
            if (this.valuation) this.openCityModal();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
  },
  methods: Object.assign({
    manageCity: function manageCity(city, updatePlaceCb, action) {
      var _this2 = this;
      var initZonesAndLocalities = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.updateSearchModalAndPlace(city, function () {
        _this2.placeTest = Object.assign({}, city);
        _this2.tempPlace = Object.assign({}, _this2.placeTest);
      });
      if (initZonesAndLocalities) {
        this.initZonesAndLocalities(getZones(city.cityID), function () {
          action && action();
          _this2.openZoneModal();
        }, function () {
          return _this2.updateSearchModalAndPlace(city, updatePlaceCb);
        });
      } else action && action();
    },
    initSingleDistrict: function initSingleDistrict(zoneId, districtId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var districts, singleDistrict;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDistrictsByZoneId(zoneId);
            case 2:
              districts = _context2.sent;
              singleDistrict = districts.find(function (d) {
                return d.districtID === districtId;
              });
              this.$set(this.districtsObj, singleDistrict === null || singleDistrict === void 0 ? void 0 : singleDistrict.zoneID, [singleDistrict]);
              //Adding the district to the district object
              this.insertDistrictByZoneId(zoneId, districtId);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    },
    onInputChangeCb: function onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (query) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return getPlacesAddressAutocomplete(query, 10);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.map(function (r) {
                return {
                  label: r.description,
                  id: r.place_id
                };
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    },
    optionSelectedCb: function optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _yield$getPlaceFromGA, place, address;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
            case 2:
              _yield$getPlaceFromGA = _context4.sent;
              place = _yield$getPlaceFromGA.place;
              address = _yield$getPlaceFromGA.address;
              this.tempPlace = place;
              this.valuationAddress = {
                label: address
              };
              this.confirmPlace();
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    },
    handleClick: function handleClick() {
      this.$refs.placeAutocomplete.select();
      this.disableCb = false;
      if (this.zoneList.length > 0 || this.localitySelected) this.showZoneModal = true;
    },
    removeTopLocalitySelected: function removeTopLocalitySelected() {
      this.cautocompleteELSelected = false;
    },
    handleChange: function handleChange(curVal) {
      if (!curVal) {
        this.clearCautocomplete();
      } else this.currentPlaceName = curVal;
    },
    closeModal: function closeModal() {
      this.pmCustomEvent = {
        type: "hide-place-modal"
      };
      this.openPlaceModal = false;
    },
    clearCautocomplete: function clearCautocomplete() {
      this.setCustomPlaceLabel("");
      this.zoneList = [];
      this.localityList = [];
      this.placeTest = null;
      this.cityModal = false;
      this.showZoneModal = false;
    },
    //Whenever we select a city from the result of the autocomplete this function will be called
    managePlace: function managePlace(obj) {
      var _this3 = this;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var initZonesAndLocalities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!obj) return;
      this.disableCb = true;
      this.resetSearchBeanZonesAndLocalities();
      var updatePlaceCb = function updatePlaceCb() {
        _this3.placeTest = Object.assign({}, obj);
        _this3.confirmPlace();
      };
      if (obj.placeType == PLACE_TYPE.CITY) {
        this.manageCity(obj, updatePlaceCb, action, initZonesAndLocalities);
      } else if (obj.placeType == PLACE_TYPE.DISTRICT) {
        this.initSingleDistrict(obj.zoneID, obj.districtID).then(function () {
          _this3.updateSearchModalAndPlace(obj, updatePlaceCb);
        });
      } else
        //e.g. if the selected option is a province...
        this.updateSearchModalAndPlace(obj, updatePlaceCb);
      this.updatePlaceName();
    },
    updatePlaceName: function updatePlaceName() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      /* LOCALITY */
      if (this.localitySelected || ((_a = this.placeTest) === null || _a === void 0 ? void 0 : _a.localityID) && !this.zoneIDsSelected.length) {
        this.updateLocationName((_b = this.localitySelected) !== null && _b !== void 0 ? _b : this.placeTest);
        return;
      }
      /* DRAWN AREA MAP */
      // eslint-disable-next-line max-len
      if (this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I" || !this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I") {
        this.currentPlaceName = this.labels.mapAreaDrawn;
      }
      /* VACATION PLACE LIKE CINQUE TERRE */else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
        this.currentPlaceName = (_c = this.searchBean) === null || _c === void 0 ? void 0 : _c.cityDisplayName;
      } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
        this.updateGenericPlaceName(this.placeTest);
      } else {
        //Zones and district greater than one
        if (this.zoneIDsSelected.length >= 0 || ((_d = this.searchBeanModal.districtIdList) === null || _d === void 0 ? void 0 : _d.length) >= 0) {
          if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(((_e = this.placeTest) === null || _e === void 0 ? void 0 : _e.placeType) || "") && !this.zoneIDsSelected.length //This check is done to exclude the following scenario: Olbia -> locality, close and open modal, select zones
          ) this.updateGenericPlaceName(this.placeTest);else if (!((_f = this.searchBeanModal.districtIdList) === null || _f === void 0 ? void 0 : _f.length) && !this.zoneIDsSelected.length) this.updateCityName(this.placeTest);else if (!this.zoneIDsSelected.length && ((_g = this.searchBeanModal.districtIdList) === null || _g === void 0 ? void 0 : _g.length) === 1 /*|| this.placeTest?.placeType === PLACE_TYPE.DISTRICT*/) this.updateSingleDistrictName(this.getSingleSelectedDistrict());else if (this.zoneIDsSelected.length === 1 && !((_h = this.searchBeanModal.districtIdList) === null || _h === void 0 ? void 0 : _h.length)) this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);else this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + ((_j = this.searchBeanModal.districtIdList) === null || _j === void 0 ? void 0 : _j.length));
        }
      }
    },
    close: function close() {
      if (this.listing) {
        this.placedIn === "agency" ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null) : this.search(this.searchBeanModal);
      } else this.emitPlace();
    },
    openCityModal: function openCityModal() {
      this.cityModal = true;
    },
    getPlaceFn: function getPlaceFn(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (query) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              this.autocompleteValue = {
                label: query
              };
              this.resetZoneAndLocalities();
              _context5.next = 6;
              return getPlace(query, "C,P,Z,L,I,R,A,D");
            case 6:
              res = _context5.sent;
              return _context5.abrupt("return", res.map(function (place, index) {
                return {
                  id: index,
                  label: place.displayName,
                  payload: place
                };
              }));
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    },
    onWholeMunicipalityClick: function onWholeMunicipalityClick() {
      var resetLocalityId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var updateCityName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.zoneIDsSelected = [];
      this.localitySelected = undefined;
      //In order to update correctly the locality id, which will be null in case we check the option "whole municipality", we set the locality id to a valid falsy value!
      if (this.placeTest && resetLocalityId) this.placeTest.localityID = 0;
      //If there is no info about the zones in and the localities in the searchBean, then we will try to search by the city!
      this.searchBeanModal.zoneId = null;
      this.searchBeanModal.zoneIdList = [];
      this.searchBeanModal.zoneURL = null;
      this.searchBeanModal.localityIdList = [];
      this.searchBeanModal.districtId = null;
      this.searchBeanModal.districtIdList = [];
      this.districtSelected = {};
      //When we select the whole municipality, we will update the current field with the name of the city!
      updateCityName && this.updateCityName(this.placeTest);
      //Updating the place modal with a valid display name
      this.placeTest = Object.assign(Object.assign({}, this.placeTest), {
        displayName: this.currentPlaceName
      });
    },
    confirmPlace: function confirmPlace() {
      var _this4 = this;
      var _a, _b;
      if (this.valuation) {
        this.publicValuation.realEstateValuation.address = ((_a = this.tempPlace) === null || _a === void 0 ? void 0 : _a.address) || "";
        this.placeTest = Object.assign({}, this.tempPlace);
        this.tempPlace = null;
        this.emitPlace();
      } else {
        /* Handling whole municipality scenario */
        if (!this.isZoneOrLocalitySelected() && !(Object.keys(this.districtSelected).length > 0) && ((_b = this.placeTest) === null || _b === void 0 ? void 0 : _b.placeType) === PLACE_TYPE.CITY) {
          this.onWholeMunicipalityClick(false, false);
        }
        this.fixSearchBean(function () {
          var _a;
          _this4.placeTest = _this4.zoneList.find(function (plc) {
            return plc.zoneID == _this4.searchBeanModal.zoneId;
          }) || _this4.placeTest;
          return (_a = _this4.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, function () {
          var _a;
          _this4.placeTest = _this4.localitySelected ? Object.assign({}, _this4.localitySelected) : _this4.placeTest;
          return (_a = _this4.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        }, function () {
          var _a;
          return (_a = _this4.placeTest) === null || _a === void 0 ? void 0 : _a.zoneURL;
        });
        this.updatePlaceName();
        delete this.searchBeanModal.polygonFromMap;
        delete this.searchBeanModal.polygonForDB;
        this.updateSearchBean({
          polygonFromMap: this.searchBeanModal.polygonFromMap,
          polygonForDB: this.searchBeanModal.polygonForDB,
          placeId: this.searchBeanModal.placeId,
          zoneIdList: this.searchBeanModal.zoneIdList,
          localityIdList: this.searchBeanModal.localityIdList,
          zoneId: this.searchBeanModal.zoneId,
          cityId: this.searchBeanModal.cityId,
          cityDisplayName: this.searchBeanModal.cityDisplayName,
          cityURL: this.searchBeanModal.cityURL,
          zoneURL: this.searchBeanModal.zoneURL,
          districtURL: this.searchBeanModal.districtURL,
          districtId: this.searchBeanModal.districtId,
          districtIdList: this.searchBeanModal.districtIdList
        });
        this.prevSearchBeanModal = deepCopy(this.searchBeanModal);
        this.prevZoneIDsSelected = _toConsumableArray(this.zoneIDsSelected);
        this.prevSelectedLocality = this.localitySelected ? Object.assign({}, this.localitySelected) : undefined;
        //Since the user has accepted its search, we can update the temp buffers!
        this.tempLocalityList = _toConsumableArray(this.localityList);
        this.tempZoneList = _toConsumableArray(this.zoneList);
        this.previousPlaceName = this.currentPlaceName;
        this.tempPlace = this.placeTest ? Object.assign({}, this.placeTest) : null;
        if (this.listing) {
          this.placedIn === "agency" ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null) : this.search(this.listing);
        } else this.emitPlace();
      }
    },
    browserSupportGeolocation: function browserSupportGeolocation() {
      return !!window.navigator.geolocation;
    },
    openMapDraw: function openMapDraw() {
      this.showMap();
    },
    openMapAroundMe: function openMapAroundMe() {
      this.aroundMe = true;
      this.openMapDraw();
    },
    hideMapModal: function hideMapModal() {
      this.showMapModal = false;
    },
    openZoneModal: function openZoneModal() {
      //Now that we have extracted from the zoneList the localities, we have to check the length of both the lists!
      if (this.valuation) return;
      this.cityModal = true;
      this.showZoneModal = !!(this.zoneList.length + this.localityList.length);
    },
    closeZoneModal: function closeZoneModal() {
      this.showZoneModal = false;
    },
    hidePlaceModal: function hidePlaceModal() {
      //Whenever we click the "go back" button, we will retrieve the previous search results!
      this.zoneList = _toConsumableArray(this.tempZoneList);
      this.localityList = _toConsumableArray(this.tempLocalityList);
      if (!this.pmCustomEvent) this.$emit("hide-place-modal");else this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
    },
    showMap: function showMap() {
      this.$emit("show-map", {
        aroundMe: this.aroundMe,
        searchBean: this.searchBeanModal
      });
    },
    emitPlace: function emitPlace() {
      var _a, _b, _c, _d;
      this.updateSearchBean({
        zoneIdList: this.searchBeanModal.zoneIdList
      });
      if (((_a = this.searchBeanModal.districtIdList) === null || _a === void 0 ? void 0 : _a.length) === 1 && !((_b = this.searchBeanModal.zoneIdList) === null || _b === void 0 ? void 0 : _b.length)) {
        if (this.placeTest) this.placeTest.districtName = (_d = (_c = this.getSingleSelectedDistrict()) === null || _c === void 0 ? void 0 : _c.districtName) !== null && _d !== void 0 ? _d : "";
      }
      this.pmCustomEvent = {
        type: "emit-place",
        payload: {
          place: this.placeTest,
          aroundMe: false,
          radius: 0,
          searchBean: this.searchBean,
          polygon: "",
          polygonFromMap: "",
          polygonForDB: ""
        }
      };
      this.openPlaceModal = false;
    }
  }, mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"]))
});